import { memo, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import styled from "styled-components";

import { useUserStore } from "stores/UserStore";

import { GenericObject } from "utility/misc";

import { RemoveLoader } from "layouts/components/RemoveLoader";
import { SpecialThing } from "layouts/components/SpecialThing";

import CelebrationOverlay from "components/CelebrationOverlay";

import FreeTrialBar from "./components/FreeTrialBar";
import Header from "./components/Header";
import LoaderModal from "./components/LoaderModal";
import Sidebar from "./components/Sidebar";

// -----------------------------------------------------------------------------

const NavLayout = memo(function NavLayout({
  noPadding,
}: NavLayoutProps): JSX.Element {
  const [userStore] = useUserStore();
  const navigate = useNavigate();

  const [renderContent, setRenderContent] = useState(false);

  //
  useEffect(
    () => (userStore.user.uuid ? setRenderContent(true) : navigate("/login")),
    [userStore, navigate]
  );

  //
  return renderContent ? (
    <>
      <SpecialThing />
      <CelebrationOverlay />
      <Header />
      <Container>
        <Sidebar />
        <MainWrapper>
          <FreeTrialBar />
          <Content noPadding={noPadding}>
            <RemoveLoader />
            <Outlet />
          </Content>
        </MainWrapper>
      </Container>
    </>
  ) : (
    <LoaderModal />
  );
});

export default NavLayout;

// -----------------------------------------------------------------------------

const Container = styled.div`
  background: #f8f8f8;
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;
  width: 100%;

  @media (max-width: 800px) {
    display: block;
  }
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const Content = styled.div.attrs(({ noPadding }: GenericObject) => ({
  noPadding,
}))`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0vw;
  height: 100%;
  width: 100%;

  padding: ${(props) =>
    props.noPadding
      ? "0"
      : "min(max(8px, calc(0.5rem + ((1vw - 3.75px) * 8.6038))), 30.8px)"};
  padding-bottom: ${(props) => (props.noPadding ? "0" : "128px")};
`;

// -----------------------------------------------------------------------------

interface NavLayoutProps {
  noPadding?: boolean;
}
